// Module
var code = `<div class="ps-detail-header">
  <button id="mlm-exit-btn" class="btn btn-icon" title="Back to list">← Back</button>
  <span class="ps-detail-name">ML Model Management</span>
  <div class="ps-detail-actions">
    <span id="mlm-status" class="ps-status"></span>
  </div>
</div>

<div class="ps-body">
  <div id="mlm-list-view" class="ps-view">
    <div class="ps-toolbar">
      <hs-toolbar-button id="mlm-refresh-btn" class="ps-icon-btn" title="↻"></hs-toolbar-button>
    </div>
    <div id="mlm-model-table" class="mlm-table-wrap"></div>
  </div>

  <div id="mlm-detail-view" class="ps-view hidden">
    <div class="ps-detail-header">
      <button id="mlm-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
      <span id="mlm-detail-name" class="ps-detail-name"></span>
    </div>
    <div class="mlm-detail-body">
      <div class="mlm-detail-col">
        <div class="mlw-param-label">Versions</div>
        <div id="mlm-versions-table" class="mlm-table-wrap"></div>
      </div>
      <div class="mlm-detail-col">
        <div id="mlm-version-detail"></div>
        </div>
      </div>
    </div>
  </div>
`;
// Exports
export default code;